import React, { useState } from 'react';
import {
  Typography,
  TextField,
  Button,
  Card,
  CardContent,
  Box,
  Paper,
  CircularProgress,
  Container
} from '@mui/material';
import {
  useMountUsageCheck,
  handleGenerateUsage,
  trackGenerationStarted,
  trackGenerationCompleted,
  trackGenerationFailed,
} from '../lib/usageGate';

const TOOL_ID = 'bcba_goal_generator';

const BCBAGoalGenerator = () => {
  const [topic, setTopic] = useState('');
  const [goals, setGoals] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useMountUsageCheck(TOOL_ID);

  const generateGoals = async () => {
    setLoading(true);
    setError(null);
    const t0 = Date.now();
    trackGenerationStarted(TOOL_ID, { topic_length: topic.length });
    try {
      const response = await fetch('/api/generateGoals', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({ topic }),
      });
      if (!response.ok) {
        throw new Error('Failed to generate goals');
      }
      const data = await response.json();
      setGoals(data.goals);
      trackGenerationCompleted(TOOL_ID, { duration_ms: Date.now() - t0 });
      handleGenerateUsage(TOOL_ID, data.usage);
    } catch (error) {
      console.error('Error generating goals:', error);
      setError('Failed to generate goals. Please try again.');
      trackGenerationFailed(TOOL_ID, { error_code: error.message });
    }
    setLoading(false);
  };

  return (
    <Container maxWidth="md">
      <Paper elevation={0} sx={{ p: 4, backgroundColor: 'white' }}>
        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            What do you want them to learn?
          </Typography>
          <TextField
            fullWidth
            value={topic}
            onChange={(e) => setTopic(e.target.value)}
            placeholder="e.g., token economy system"
            variant="outlined"
            sx={{ 
              backgroundColor: 'white',
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: 'primary.main',
                },
                '&:hover fieldset': {
                  borderColor: 'primary.dark',
                },
              },
            }}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={generateGoals}
            disabled={loading || !topic}
            sx={{ mt: 2 }}
          >
            Generate Goals
          </Button>
        </Box>
        {loading && <CircularProgress />}
        {error && (
          <Typography color="error" sx={{ mt: 2 }}>
            {error}
          </Typography>
        )}
        {goals.length > 0 && (
          <Box>
            <Typography variant="h5" gutterBottom>
              Generated Parent Training Goals and Mastery Criteria
            </Typography>
            {goals.map((goal, index) => (
              <Card 
                key={index} 
                sx={{ 
                  mb: 2, 
                  border: 1, 
                  borderColor: 'primary.main',
                  boxShadow: 'none'
                }}
              >
                <CardContent>
                  <Typography variant="h6">{goal.title}</Typography>
                  <Typography><strong>Goal:</strong> {goal.goal}</Typography>
                  <Typography><strong>Mastery Criteria:</strong> {goal.masteryCriteria}</Typography>
                </CardContent>
              </Card>
            ))}
          </Box>
        )}
      </Paper>
    </Container>
  );
};

export default BCBAGoalGenerator;